import { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../App";
import { useParams } from "react-router-dom";
import { action, controller, Server } from "../../api/Server";
import SearchProd from "./SearchProd";
import { Inventory2Outlined } from "@mui/icons-material";
import CategoryList from "./CategoryList";
import { ToFormData } from "../../hooks/Method";
import ProdWidget from "./ProdWidget";

const Products = ({ cartItems, setCartItems }) => {
  const { t } = useTranslation();
  const { settings, selStore, setLoader, loader } = useContext(AppContext);
  const { catId } = useParams();
  const [prods, setProds] = useState([]);

  useEffect(() => {
    getDefaultPosItems(catId);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore, catId]);

  const getDefaultPosItems = (categoryId) => {
    if (selStore) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        if (res && res.status === 200) setProds([...res.result]);
        else {
          setProds([]);
          res && console.error("POS Products getting error: ", res.msg);
        }
      };

      categoryId // Get Products by category
        ? Server(controller.Product + action.GetProdsByCat).post(
            ToFormData({
              storeId: selStore,
              catId: categoryId,
            }),
            onComplete
          )
        : // Get default products
          Server(controller.PosItem + action.GetDefaultPosItems).get(
            onComplete
          );
    }
  };

  const handleCart = (prod) => {
    const cartVal = cartItems.find((j) => j.productId === prod.id);
    if (
      !settings.enableInventoryReq ||
      (prod.inventory > 0 && prod.inventory > (cartVal?.qty || 0))
    ) {
      if (cartVal) {
        setCartItems((x) => [
          ...x.map((j) =>
            j.productId === prod.id ? { ...j, qty: parseInt(j.qty) + 1 } : j
          ),
        ]);
      } else {
        var priceDtl = prod && prod.sellPrices[0];
        setCartItems((x) => [
          {
            productId: prod.id,
            barcode: prod.barcode,
            label: prod.label,
            price: priceDtl ? priceDtl.price : 0,
            priceId: priceDtl ? priceDtl.id : "",
            prices: prod
              ? prod.sellPrices.map((j) => ({
                  ...j,
                  label: `${settings.curSymbol} ${j.price.toFixed(
                    settings.decimal
                  )}`,
                  subtitle: j.title,
                }))
              : [],
            tax: prod.tax,
            qty: 1,
          },
          ...x,
        ]);
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchProd {...{ setProds, handleCart, getDefaultPosItems }} />
      </Grid>
      <Grid item xs={12}>
        <CategoryList />
      </Grid>
      <Grid item xs={12} sx={{ paddingTop: "0px !important" }}>
        <Box
          sx={{
            maxHeight: "62vh",
            overflowY: "auto",
            pr: 1,
          }}
        >
          <Grid container spacing={1}>
            {!loader && prods.length > 0 ? (
              prods.map((prod, i) => (
                <Grid item xs={6} sm={3} xl={2} key={i}>
                  <ProdWidget {...{ handleCart, prod }} />
                </Grid>
              ))
            ) : loader ? (
              <span className="fs-24 gray-color fw-5 p-30">
                {t("loading")}...
              </span>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  mt: "60px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "gray",
                  textAlign: "center",
                }}
              >
                <Inventory2Outlined sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h6" fontWeight={500}>
                  {t("noProductsToDisplay")}
                </Typography>
                <Typography variant="body2">
                  {t("posPordNotFoundSubtitle")}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Products;
